module.exports = __webpack_public_path__ + "static/media/AY_Skin_Specialist_Clinic_Xmas_2018.53ce5948.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/slides/201812/AY_Skin_Specialist_Clinic_Xmas_2018.pdf
// module id = 642
// module chunks = 0